/**
 * Splits `text` around the first place `query` occurs, ignoring case and
 * accents, so "societe" highlights inside "Société Générale". Mirrors the
 * server's normalisation (common/search/search-text.util.ts) closely enough
 * for display; the server decides what matched, this only decides what to bold.
 */
export interface HighlightParts {
  before: string;
  match: string;
  after: string;
}

function fold(char: string): string {
  return char
    .normalize('NFKD')
    .replace(/\p{M}+/gu, '')
    .toLowerCase();
}

export function highlightParts(text: string, query: string): HighlightParts {
  const needle = query.trim().replace(/^[a-z]+:\s*/i, '');
  if (!text || !needle) return { before: text, match: '', after: '' };

  // Fold character by character, remembering where each folded character came from.
  let folded = '';
  const origin: number[] = [];
  for (let i = 0; i < text.length; i += 1) {
    const piece = fold(text[i]);
    for (let j = 0; j < piece.length; j += 1) {
      folded += piece[j];
      origin.push(i);
    }
  }
  const foldedNeedle = Array.from(needle).map(fold).join('');
  const at = folded.indexOf(foldedNeedle);
  if (at < 0) return { before: text, match: '', after: '' };
  const start = origin[at];
  const end = origin[at + foldedNeedle.length - 1] + 1;
  return { before: text.slice(0, start), match: text.slice(start, end), after: text.slice(end) };
}
